var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayCount)?_c('span',{staticClass:"mp-unread",class:_vm.sizeClass,attrs:{"title":(_vm.displayCount + " unread")}},[_vm._v(_vm._s(_vm.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }